// extracted by mini-css-extract-plugin
export var container = "index-module--container--x7bvz";
export var logo = "index-module--logo--ctS7e";
export var searchIcon = "index-module--searchIcon--MBF2t";
export var title = "index-module--title--9xZzi";